import { defineStore } from 'pinia';

interface StudentStore extends Domain.Students.Resources.MyFJV2.StudentResource {
  has_unread_notifications: boolean;
  all_students: App.Http.Resources.Login.UserMyFJV2Resource['all_students']
}

export const useStudentStore = defineStore('student', {
  state: (): StudentStore => ({
      id: 0,
      full_name: '',
      is_trial: false,
      has_unread_notifications: false,
      unread_notification_count: 0,
      parent_group_id: null,
      sub_group_id: null,
      organisation: {
        id: 0,
        name: '',
        logo_src: null,
        require_year_selection: false,
        require_subgroup_selection: false,
        year_sub_group_known_as: '',
        custom_background_url: null,
        custom_background_mobile_url: null,
      },
      user: {
        id: 0,
        type: '',
        full_name: '',
        locale: null,
        timezone: ''
      },
      settings: {
        font_style: 'inherit',
        background_image: 'inherit',
      },
      all_students: [],
  }),
  actions: {
    setAllStudentsData(all_students: App.Http.Resources.Login.UserMyFJV2Resource['all_students']) {
      this.all_students = all_students;
    },

    setStudentData({ id, full_name, is_trial, unread_notification_count, parent_group_id, sub_group_id, organisation, settings, user }: Domain.Students.Resources.MyFJV2.StudentResource) {
      this.id = id;
      this.full_name = full_name;
      this.is_trial = is_trial;
      this.has_unread_notifications = unread_notification_count > 0;
      this.unread_notification_count = unread_notification_count;
      this.parent_group_id = parent_group_id;
      this.sub_group_id = sub_group_id;

      this.settings = {
        font_style: settings.font_style,
        background_image: settings.background_image,
      };

      if (organisation) {
        this.organisation = {
          id: organisation.id,
          name: organisation.name,
          logo_src: organisation.logo_src,
          require_year_selection: organisation.require_year_selection,
          require_subgroup_selection: organisation.require_subgroup_selection,
          year_sub_group_known_as: organisation.year_sub_group_known_as,
          custom_background_url: organisation.custom_background_url,
          custom_background_mobile_url: organisation.custom_background_mobile_url,
        };
      }

      if (user) {
        this.user = {
          id: user.id,
          type: user.type,
          full_name: user.full_name,
          locale: user.locale,
          timezone: user.timezone,
        };
      }

    },
    notificationRead() {
      this.unread_notification_count--;
      this.has_unread_notifications = this.unread_notification_count > 0;
    },
  },
  getters: {
    fontStyle: (state) => state.settings.font_style,
    backgroundImage: (state) => state.settings.background_image,
    customBackgroundUrl: (state) => state.organisation.custom_background_url,
    customBackgroundMobileUrl: (state) => state.organisation.custom_background_mobile_url,
    hasCustomBackground: (state) => !!state.organisation.custom_background_url,
    hasMultipleStudents: (state) => (state.all_students?.length || 0) > 1,
    noCurrentStudent: (state) => !state.all_students?.some((student: any) => student.is_current),
    setCurrentStudentRequired(): boolean {
      return this.hasMultipleStudents && this.noCurrentStudent;
    },
    yearOrYearGroupSelectionRequired: (state) => (state.organisation.require_year_selection && !state.parent_group_id) || (state.organisation.require_subgroup_selection && !state.sub_group_id),
  },
});
